/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { deleteRemoveOrganizationThunk, deleteValidateRemoveOrganizationThunk } from './organization.remove.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  dialog: { open: false },
  resultDialog: { open: false },
  error: undefined,
};

/* Slice */
export const removeOrganizationSlice = createSlice({
  name: 'removeOrganization',
  initialState,
  reducers: {
    toggleRemoveOrgDialog(state, action) {
      state.dialog.open = action.payload;
    },
    toggleResultDialog(state, action) {
      state.resultDialog.open = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(deleteValidateRemoveOrganizationThunk.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(deleteValidateRemoveOrganizationThunk.fulfilled, (state) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.dialog.open = true;
        state.error = undefined;
      })
      .addCase(deleteValidateRemoveOrganizationThunk.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.resultDialog.open = true;
        state.error = action?.error?.message;
      })
      .addCase(deleteRemoveOrganizationThunk.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(deleteRemoveOrganizationThunk.fulfilled, (state, action) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.users = action.payload;
        state.dialog.open = false;
        state.resultDialog.open = true;
        state.error = undefined;
      })
      .addCase(deleteRemoveOrganizationThunk.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.resultDialog.open = true;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectRemoveOrglice = state => state[removeOrganizationSlice.name];

export const selectDialog = createSelector(selectRemoveOrglice, s => s.dialog);
export const selectStatus = createSelector(selectRemoveOrglice, s => s.status);
export const selectError = createSelector(selectRemoveOrglice, s => s.error);
export const selectResultDialog = createSelector(selectRemoveOrglice, s => s.resultDialog);

/* Actions */
export const { toggleRemoveOrgDialog, toggleResultDialog } = removeOrganizationSlice.actions;
